import React from 'react';

import { IModal, IModalContext } from './interfaces';

export const ModalContext = React.createContext({} as IModalContext);

export const ModalProvider = ({ children, onSubmit, onClose }: IModal) => {
  return (
    <ModalContext.Provider value={{ onSubmit, onClose } as IModalContext}>
      {children}
    </ModalContext.Provider>
  );
};
